<template>
  <footer class="footer footer--en" id="footer-section">
    <div class="content">
      <hr id="footer-hr">
      <div class="footer-content">
        <a class="footer-logo" :href="route">
          <img src="@/assets/img/logo.svg" alt="Logo"/>
          <span>Getfloorplan</span>
        </a>
        <div class="footer-content-block footer-content-block--desktop">
          <p class="footer-content-main">© 2020-{{ year }}, All rights reserved.</p>
          <a href="https://www.freepik.com" target="_blank">Image by freepik.com</a>
          <a href="https://deepgram.com/?utm_source=getfloorplan&utm_medium=referral" target="_blank">Published on Deepgram</a>
        </div>
        <div class="footer-content-block">
          <router-link class="footer-content-terms-and-conditions" :to="{ path: '/terms-and-conditions' }" target="_blank" rel="noreferrer">Terms and conditions</router-link>
          <router-link class="footer-content-privacy-policy" :to="{ path: '/privacy-policy' }" target="_blank" rel="noreferrer">Privacy policy</router-link>
        </div>
        <div class="footer-content-block">
          <a class="footer-content-email" href="mailto:support@getfloorplan.com">support@getfloorplan.com</a>
          <a class="footer-content-email" href="mailto:marketing@getfloorplan.com">marketing@getfloorplan.com</a>
        </div>
        <div class="footer-icons">
          <a :href="socialLinks.instagram" target="_blank">
            <img src="@/assets/img/footer/instagram-icon.svg" alt="instagram-icon"/>
          </a>
          <a :href="socialLinks.pinterest" target="_blank">
            <img src="@/assets/img/footer/pinterest-icon.svg" alt="pinterest-icon"/>
          </a>
          <a :href="socialLinks.facebook" target="_blank">
            <img src="@/assets/img/footer/facebook-icon.svg" alt="facebook-icon"/>
          </a>
          <a :href="socialLinks.linkedin" target="_blank">
            <img src="@/assets/img/footer/linkedin-icon.svg" alt="linkedin-icon"/>
          </a>
          <a :href="socialLinks.twitter" target="_blank">
            <img src="@/assets/img/footer/twitter-icon.svg" alt="twitter-icon"/>
          </a>
          <a :href="socialLinks.youtube" target="_blank">
            <img src="@/assets/img/footer/youtube-icon.svg" alt="youtube-icon"/>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { socialLinks } from '@/helpers';

export default {
  name: 'FooterEn',
  data() {
    return {
      socialLinks: {
        instagram: socialLinks.instagram,
        facebook: socialLinks.facebook,
        linkedin: socialLinks.linkedin,
        twitter: socialLinks.twitter,
        youtube: socialLinks.youtube,
        pinterest: socialLinks.pinterest,
      },
    route: '',
    year: '',
    };
  },
  created() {
    this.route = window.location.origin;
    const data = new Date();
    this.year = data.getFullYear();
  },
  methods: {

  },
};
</script>
